import { useTranslation } from 'next-i18next';
import { useCartContext } from '../../../context/cartContext';
import { useStar2 } from '../../../hooks/useStar2';
import { Container, Divider, Header, ItemCount, Subheading, Total } from './SummaryBar.styles';

type SummaryBarProps = {
  currency: string;
  total: string;
  className?: string;
  testId?: string;
  isGlobalECheckout?: boolean;
};

export function SummaryBar({ currency, total, className, testId, isGlobalECheckout }: SummaryBarProps) {
  const { t } = useTranslation(['lib-global-common']);
  const { itemsInCart, isCartEmpty } = useCartContext();
  const { isStar2 } = useStar2();

  return (
    <Container className={className} data-testid={testId} $isStar2={!!isStar2}>
      <Header>{isCartEmpty ? t('cart.summary.bar.header.empty') : t('cart.summary.bar.header')}</Header>
      {!isCartEmpty && (
        <Subheading>
          <ItemCount data-testid="cartItemCount">{t('cart.summary.items', { count: itemsInCart })}</ItemCount>
          {!isGlobalECheckout && <Divider> | </Divider>}
          <Total data-testid="cartTotal">
            {currency}
            {total}
          </Total>
        </Subheading>
      )}
    </Container>
  );
}
